import { CSSProperties, FC } from 'react';
import styles from './BackButton.module.scss';
import { ReactComponent as IconBack } from '../../assets/back.svg';

interface BackButtonProps {
  disabled?: boolean;
  title: string;
  style?: CSSProperties;
  onClick: () => void;
}

const BackButton: FC<BackButtonProps> = ({ disabled, title, style, onClick }) => (
  <button className={styles.back} onClick={onClick} disabled={disabled} style={style}>
    <IconBack />
    <span>{title}</span>
  </button>
);
export default BackButton;
